import { SortMode } from './SortMode';

export class Sorting {
  public sortBy: string;
  public sortMode: SortMode;

  constructor(sortBy: string, sortMode: SortMode = 'ascending') {
    this.sortBy = sortBy;
    this.sortMode = sortMode;
  }
}
